export default "assets/images/icons/linkedin-63ebb4e2.svg";